import styled from 'styled-components'

import ReactGA from 'react-ga4'
import LeftBar from '../home/components/leftBar'
import PriceResearch from './PriceResearch'

const Page = styled.div`
    display: flex;
    height: 100vh;
    overflow: hidden !important;
`

export default function PesquisaPrecos() {
    ReactGA.send({
        hitType: 'pageview',
        page: '/pesquisa-precos',
        title: 'Pesquisa de Preços',
    })

    return (
        <Page>
            <LeftBar />
            <PriceResearch />
        </Page>
    )
}
